var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _g, _path11, _g2, _path12, _g3, _path13, _g4, _g5, _path14, _path15, _path16, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 386,
    height: 184,
    viewBox: "0 0 386 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M274.41 90.0789C274.41 108.434 268.264 125.681 258.021 139.289C252.348 146.726 245.572 153.213 237.693 158.276C225.086 166.663 209.8 171.41 193.569 171.41C148.973 171.568 112.729 135.175 112.729 90.0789C112.729 45.1414 148.815 8.59009 193.569 8.59009C209.8 8.59009 224.929 13.337 237.693 21.7232C245.572 26.7866 252.348 33.2741 258.021 40.7109C268.264 54.477 274.41 71.5659 274.41 90.0789Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M132.003 79.1845H131.028C130.296 79.1845 129.808 78.9568 129.808 78.6152C129.808 78.2736 130.296 78.0459 131.028 78.0459H132.003C132.735 78.0459 133.223 78.2736 133.223 78.6152C133.223 78.9568 132.735 79.1845 132.003 79.1845Z",
    fill: "#2D5887"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M132.003 83.7375H131.028C130.296 83.7375 129.808 83.5098 129.808 83.1682C129.808 82.8266 130.296 82.5989 131.028 82.5989H132.003C132.735 82.5989 133.223 82.8266 133.223 83.1682C133.223 83.5098 132.735 83.7375 132.003 83.7375Z",
    fill: "#2D5887"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M132.003 88.2934H131.028C130.296 88.2934 129.808 88.0657 129.808 87.7241C129.808 87.3825 130.296 87.1548 131.028 87.1548H132.003C132.735 87.1548 133.223 87.3825 133.223 87.7241C133.223 88.0657 132.735 88.2934 132.003 88.2934Z",
    fill: "#2D5887"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M132.003 92.8464H131.028C130.296 92.8464 129.808 92.6186 129.808 92.2771C129.808 91.9355 130.296 91.7078 131.028 91.7078H132.003C132.735 91.7078 133.223 91.9355 133.223 92.2771C133.223 92.6186 132.735 92.8464 132.003 92.8464Z",
    fill: "#2D5887"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M176.544 79.1845H160.496C159.845 79.1845 159.411 78.9568 159.411 78.6152C159.411 78.2736 159.845 78.0459 160.496 78.0459H176.544C177.195 78.0459 177.629 78.2736 177.629 78.6152C177.629 78.9568 177.195 79.1845 176.544 79.1845Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M210.739 92.8464H160.459C159.83 92.8464 159.411 92.6186 159.411 92.2771C159.411 91.9355 159.83 91.7078 160.459 91.7078H210.739C211.368 91.7078 211.787 91.9355 211.787 92.2771C211.787 92.6186 211.368 92.8464 210.739 92.8464Z",
    fill: "url(#paint0_linear_1501_9717)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M176.607 83.7375H154.74C154.127 83.7375 153.718 83.5098 153.718 83.1682C153.718 82.8266 154.127 82.5989 154.74 82.5989H176.607C177.22 82.5989 177.629 82.8266 177.629 83.1682C177.629 83.5098 177.22 83.7375 176.607 83.7375Z",
    fill: "#2D5887"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M193.688 88.2934H154.738C154.126 88.2934 153.718 88.0657 153.718 87.7241C153.718 87.3825 154.126 87.1548 154.738 87.1548H193.688C194.3 87.1548 194.708 87.3825 194.708 87.7241C194.504 88.0657 194.096 88.2934 193.688 88.2934Z",
    fill: "#2D5887"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M210.678 88.2934H195.817C195.151 88.2934 194.708 88.0657 194.708 87.7241C194.708 87.3825 195.151 87.1548 195.817 87.1548H210.678C211.343 87.1548 211.787 87.3825 211.787 87.7241C211.787 88.0657 211.343 88.2934 210.678 88.2934Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M219.819 88.2934H214.002C213.356 88.2934 212.925 88.0657 212.925 87.7241C212.925 87.3825 213.356 87.1548 214.002 87.1548H219.819C220.465 87.1548 220.896 87.3825 220.896 87.7241C220.896 88.0657 220.465 88.2934 219.819 88.2934Z",
    fill: "url(#paint1_linear_1501_9717)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M94.511 151.914H285.796",
    stroke: "#D6DEE8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1501_9717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.866 78.0459V150.916H125.554C121.478 150.916 118.422 147.641 118.422 143.752V78.0459H228.866Z",
    fill: "white"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M269.855 78.0459V143.752C269.855 147.846 266.457 150.916 262.422 150.916H228.866V78.0459H269.855Z",
    fill: "#DAE1ED"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1501_9717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.855 78.0459V143.752C269.855 147.846 266.457 150.916 262.422 150.916H228.866V78.0459H269.855Z",
    fill: "#E7EAF4"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M158.273 78.0452L179.997 43.8872H291.489L269.15 78.0452H158.273Z",
    fill: "#C5CDDB"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1501_9717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M158.273 78.0452L179.997 43.8872H291.489L269.15 78.0452H158.273Z",
    fill: "url(#paint2_linear_1501_9717)"
  }))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M269.855 78.2454V116.758H239.967C237.192 116.758 235.27 114.962 234.844 112.368L228.866 78.0459L269.855 78.2454Z",
    fill: "url(#paint3_linear_1501_9717)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1501_9717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M268.997 78.0459H228.866L249.243 108.931C250.699 110.977 252.986 112.204 255.273 112.204H286.463C288.542 112.204 289.998 109.749 288.75 108.113L268.997 78.0459Z",
    fill: "url(#paint4_linear_1501_9717)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1501_9717)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M228.866 78.0452L206.989 43.8872H94.511L117.213 78.0452H228.866Z",
    fill: "#E7EAF4"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 120.174H130.48C129.474 120.174 128.669 119.415 128.669 118.466C128.669 117.517 129.474 116.758 130.48 116.758H173.541C174.547 116.758 175.352 117.517 175.352 118.466C175.15 119.415 174.547 120.174 173.541 120.174Z",
    fill: "#DAE1ED"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M173.541 128.144H130.48C129.474 128.144 128.669 127.638 128.669 127.005C128.669 126.373 129.474 125.867 130.48 125.867H173.541C174.547 125.867 175.352 126.373 175.352 127.005C175.15 127.638 174.547 128.144 173.541 128.144Z",
    fill: "#DAE1ED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M150.74 137.253H130.508C129.487 137.253 128.669 136.746 128.669 136.114C128.669 135.481 129.487 134.975 130.508 134.975H150.74C151.762 134.975 152.58 135.481 152.58 136.114C152.375 136.746 151.558 137.253 150.74 137.253Z",
    fill: "#DAE1ED"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1501_9717",
    x: 96.4216,
    y: 67.0459,
    width: 154.444,
    height: 116.87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1501_9717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1501_9717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1501_9717",
    x: 206.866,
    y: 67.0459,
    width: 84.9896,
    height: 116.87,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1501_9717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1501_9717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1501_9717",
    x: 136.273,
    y: 32.8872,
    width: 177.216,
    height: 78.158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1501_9717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1501_9717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1501_9717",
    x: 206.866,
    y: 67.0459,
    width: 104.346,
    height: 78.158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1501_9717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1501_9717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1501_9717",
    x: 72.511,
    y: 32.8872,
    width: 178.355,
    height: 78.158,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1501_9717"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1501_9717",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1501_9717",
    x1: 159.647,
    y1: 92.3002,
    x2: 211.848,
    y2: 92.3002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF66A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F53689"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1501_9717",
    x1: 212.979,
    y1: 87.6892,
    x2: 220.894,
    y2: 87.6892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#83A6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A78FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1501_9717",
    x1: 224.837,
    y1: 43.0971,
    x2: 224.837,
    y2: 78.4135,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1501_9717",
    x1: 249.37,
    y1: 117.553,
    x2: 249.37,
    y2: 82.2905,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00289017,
    stopColor: "#606673",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAB2C5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1501_9717",
    x1: 259.019,
    y1: 77.2558,
    x2: 259.019,
    y2: 112.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.e115eaa1f639974518966c6c643b7eb3.svg";
export { ForwardRef as ReactComponent };